/* eslint-disable */

function extend() {
  const result = {};
  for (let i = 0; i < arguments.length; i++) {
    const attributes = arguments[i];
    for (const key in attributes) {
      result[key] = attributes[key];
    }
  }
  return result;
}

function decode(s) {
  return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
}

function GetCookieDomain() {
  var host = location.hostname;
  var ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (ip.test(host) === true || host === 'localhost') return host;
  var regex = /([^]*).*/;
  var match = host.match(regex);
  if (typeof match !== 'undefined' && null !== match) host = match[1];
  if (typeof host !== 'undefined' && null !== host) {
    var strAry = host.split('.');
    if (strAry.length > 1) {
      host = strAry[strAry.length - 2] + '.' + strAry[strAry.length - 1];
    }
  }
  return '.' + host;
}

function init(converter) {
  function set(key, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }

    attributes = extend(api.defaults, attributes);

    // 设置expires时间
    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e5);
    }
    attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

    // 设置域名
    // attributes.domain = GetCookieDomain();

    try {
      const result = JSON.stringify(value);
      if (/^[{[]/.test(result)) {
        value = result;
      }
    } catch (e) {}

    value = converter.write
      ? converter.write(value, key)
      : encodeURIComponent(String(value)).replace(
          /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
          decodeURIComponent,
        );

    key = encodeURIComponent(String(key))
      .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    let stringifiedAttributes = '';
    for (const attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += `; ${attributeName}`;
      if (attributes[attributeName] === true) {
        continue;
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += `=${attributes[attributeName].split(';')[0]}`;
    }

    return (document.cookie = `${key}=${value}${stringifiedAttributes}`);
  }

  function get(key, json) {
    if (typeof document === 'undefined') {
      return;
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    const jar = {};
    for (let i = 0; i < cookies.length; i++) {
      const parts = cookies[i].split('=');
      let cookie = parts.slice(1).join('=');

      if (!json && cookie.charAt(0) === '"') {
        cookie = cookie.slice(1, -1);
      }

      try {
        const name = decode(parts[0]);

        cookie = (converter.read || converter)(cookie, name) || decode(cookie);

        if (json) {
          try {
            cookie = JSON.parse(cookie);
          } catch (e) {}
        }

        jar[name] = cookie;

        if (key === name) {
          break;
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar;
  }

  var api = {
    defaults: {
      path: '/',
    },
    set,
    get(key) {
      if (arguments.length && !key) {
        return;
      }
      return get(key /* read as raw */);
    },
    getJSON(key) {
      if (arguments.length && !key) {
        return;
      }
      return get(key, true /* read as json */);
    },
    remove(key, attributes) {
      set(
        key,
        '',
        extend(attributes, {
          expires: -1,
        }),
      );
    },
    withConverter: init,
  };

  return api;
}

export default init(() => {});

/* eslint-enable */
